export default {
  getHead: () => {
    return [{name: '회사명'}, {name: '사업장명'}, {name: '평가종류'}, {name: '유해·위험요인'}, {name: '평가자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.section // 회사명
        case 1: return func.getContent(value).stdInfo.field_name // 사업장명
        case 2: return func.getContent(value).inputB_1 // 평가종류
        case 3: return func.getContent(value).factorList.join(" ") // 유해·위험요인
        case 4: return func.getContent(value).inputB_2 // 평가자
        case 5: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
      case '회사명': return ['content$body.stdInfo.section*%[:default_skw]%']
      case '사업장명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
      case '평가종류': return ['content$body.inputB_1*%[:default_skw]%']
      case '유해위험요인': return ['content$body.factorString*%[:default_skw]%']
      case '평가자':  return ['content$body.inputB_2*%[:default_skw]%']
    }
    return []
  },
}
